import { toast } from "react-toastify";
import api from "../../api/api";
import {
  FETCH_ACCESS_APPROVAL_REQUESTS_REQUEST,
  FETCH_ACCESS_APPROVAL_REQUESTS_SUCCESS,
  FETCH_ACCESS_APPROVAL_REQUESTS_FAILURE,
  FETCH_USER_ACCESS_REQUEST_REQUEST,
  FETCH_USER_ACCESS_REQUEST_SUCCESS,
  FETCH_USER_ACCESS_REQUEST_FAILURE,
  REQUEST_ACCESS_REQUEST,
  REQUEST_ACCESS_SUCCESS,
  REQUEST_ACCESS_FAILURE,
  APPROVE_ACCESS_REQUEST_REQUEST,
  APPROVE_ACCESS_REQUEST_SUCCESS,
  APPROVE_ACCESS_REQUEST_FAILURE,
  REJECT_ACCESS_REQUEST_REQUEST,
  REJECT_ACCESS_REQUEST_SUCCESS,
  REJECT_ACCESS_REQUEST_FAILURE,
} from "../actions/accessRequestActionTypes";





// Fetch Access Approval Requests (Admin side)
export const fetchAccessApprovalRequests = () => async (dispatch) => {
  dispatch({ type: FETCH_ACCESS_APPROVAL_REQUESTS_REQUEST });

  try {

    const response = await api.get("/Requests", {
      // headers: {
      //   Authorization: `Bearer ${localStorage.getItem("token")}`,
      //   "Content-Type": "application/json",
      //   Accept: "*/*",
      // },
    });
    dispatch({
      type: FETCH_ACCESS_APPROVAL_REQUESTS_SUCCESS,
      payload: response.data,
    });

    // toast.success("Access approval requests fetched successfully.");
  } catch (error) {
    const errorMessage = error.message || "Something went wrong while fetching approval requests.";
    console.error("API - fetchAccessApprovalRequests error:", errorMessage);

    dispatch({
      type: FETCH_ACCESS_APPROVAL_REQUESTS_FAILURE,
      payload: errorMessage,
    });

  }
};




export const fetchUserAccessRequest = (userId) => async (dispatch) => {
  dispatch({ type: FETCH_USER_ACCESS_REQUEST_REQUEST });
  try {
    const response = await api.get(`/Requests/by-user/${userId}`);
    dispatch({
      type: FETCH_USER_ACCESS_REQUEST_SUCCESS,
      payload: response.data,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_ACCESS_REQUEST_FAILURE,
      payload: err.message,
    });
  }
};




// Approve Access Request (Admin side)
export const approveAccessRequest = (requestId) => async (dispatch) => {
  dispatch({ type: APPROVE_ACCESS_REQUEST_REQUEST });

  try {
    console.log("API - approving access request:", requestId);

    const response = await api.post(
      `/Requests/${requestId}/approve`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      }
    );

    console.log("API - approveAccessRequest response:", response);

    if (response.status === 200) {
      dispatch({
        type: APPROVE_ACCESS_REQUEST_SUCCESS,
        payload: response.data,
      });
      toast.success("Access request approved successfully.");
    } else if (response.status === 400) {
      const message = "The email address is already registered.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else if (response.status === 401) {
      const message = "You are not authorized. Please log in again.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else if (response.status === 403) {
      const message = "You do not have permission to approve this request.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else if (response.status === 404) {
      const message = "The request was not found.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else if (response.status === 500) {
      const message = "Server error. Please try again later.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else {
      const message =
        response.data?.message || `Unexpected error (status ${response.status}).`;
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    }
  } catch (error) {
    const status = error.response?.status;

    if (status === 400) {
      const message = "The email address is already registered.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else if (status === 401) {
      const message = "You are not authorized. Please log in again.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else if (status === 403) {
      const message = "You do not have permission to approve this request.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else if (status === 404) {
      const message = "The request was not found.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else if (status === 500) {
      const message = "Server error. Please try again later.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    } else {
      const message =
        error.response?.data?.message ||
        error.message ||
        "Something went wrong while approving access request.";
      dispatch({ type: APPROVE_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    }

    console.error("API - approveAccessRequest error:", error);
  }
};



// Reject Access Request (Admin side)
// export const rejectAccessRequest = (requestId) => async (dispatch) => {
//   dispatch({ type: REJECT_ACCESS_REQUEST_REQUEST });

//   try {
//     console.log("API - rejecting access request:", requestId);

//     const response = await api.post(
//       `/Requests/${requestId}/reject`,
//       {},
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           "Content-Type": "application/json",
//           Accept: "*/*",
//         },
//       }
//     );

//     console.log("API - rejectAccessRequest response:", response);

//     if (response.status === 200) {
//       dispatch({
//         type: REJECT_ACCESS_REQUEST_SUCCESS,
//         payload: response.data,
//       });
//       toast.success("Access request rejected successfully.");
//     } else if (response.status === 400) {
//       const message = "The request could not be processed (bad request).";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else if (response.status === 401) {
//       const message = "You are not authorized. Please log in again.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else if (response.status === 403) {
//       const message = "You do not have permission to reject this request.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else if (response.status === 404) {
//       const message = "The request was not found.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else if (response.status === 500) {
//       const message = "Server error. Please try again later.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else {
//       const message =
//         response.data?.message || `Unexpected error (status ${response.status}).`;
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     }
//   } catch (error) {
//     const status = error.response?.status;

//     if (status === 400) {
//       const message = "The request could not be processed (bad request).";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else if (status === 401) {
//       const message = "You are not authorized. Please log in again.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else if (status === 403) {
//       const message = "You do not have permission to reject this request.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else if (status === 404) {
//       const message = "The request was not found.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else if (status === 500) {
//       const message = "Server error. Please try again later.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     } else {
//       const message =
//         error.response?.data?.message ||
//         error.message ||
//         "Something went wrong while rejecting access request.";
//       dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
//       toast.error(message);
//     }

//     console.error("API - rejectAccessRequest error:", error);
//   }
// };

export const rejectAccessRequest = (requestId, comment) => async (dispatch) => {
  dispatch({ type: REJECT_ACCESS_REQUEST_REQUEST });

  try {
    console.log("API - rejecting access request:", requestId, comment);

    const response = await api.post(
      `/Requests/${requestId}/reject`,
      { comment }, // ✅ Send comment in body
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Accept: "*/*",
        },
      }
    );

    console.log("API - rejectAccessRequest response:", response);

    if (response.status === 200) {
      dispatch({
        type: REJECT_ACCESS_REQUEST_SUCCESS,
        payload: response.data,
      });
      toast.success("Access request rejected successfully.");
    } else {
      const message = response.data?.message || `Unexpected error (status ${response.status}).`;
      dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
      toast.error(message);
    }
  } catch (error) {
    const status = error.response?.status;
    const message =
      error.response?.data?.message ||
      (status === 401
        ? "You are not authorized. Please log in again."
        : status === 403
        ? "You do not have permission to reject this request."
        : status === 404
        ? "The request was not found."
        : status === 500
        ? "Server error. Please try again later."
        : "Something went wrong while rejecting access request.");

    dispatch({ type: REJECT_ACCESS_REQUEST_FAILURE, payload: message });
    toast.error(message);
    console.error("API - rejectAccessRequest error:", error);
  }
};



// Request Access to Platform (User side)
export const requestAccess = (accessData) => async (dispatch) => {
  dispatch({ type: REQUEST_ACCESS_REQUEST });

  try {
    console.log("API - requesting access with data:", accessData);

    // Convert to FormData
    const formData = new FormData();
    formData.append("CompanyName", accessData.CompanyName);
    formData.append("ContactPerson", accessData.ContactPerson);
    formData.append("Email", accessData.Email);

    const response = await api.post("/Requests", formData, {
      headers: {
        Accept: "*/*",
      },
    });

    console.log("API - requestAccess response:", response.data);

    dispatch({
      type: REQUEST_ACCESS_SUCCESS,
      payload: response.data,
    });

    toast.success("Submitted successfully, please check your email to set your password");

    window.location.href = "https://liberiachamber.org"; //Reroute the user to the website
    
  } catch (error) {
    console.error("API - requestAccess full error:", error);
    console.error("API - requestAccess error response:", error.response?.data);

    const errorMessage = error.response?.data?.errors
      ? Object.values(error.response.data.errors).flat().join(", ")
      : error.message || "Something went wrong while submitting access request.";

    console.error("API - requestAccess error:", errorMessage);

    dispatch({
      type: REQUEST_ACCESS_FAILURE,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};
